import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const ExtendedTextEntrySelectionsReducer = () => [];

export const ExtendedTextEntrySelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(ExtendedTextEntrySelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(ExtendedTextEntrySelectionsReducer),
};
